<pc-header class="header-container" [minHeaderHeight]="hData().headerHeight">
  <div class="header">
    <pc-icon
      [altText]="hData().logAltText"
      [ariaHidden]="false"
      [class.standalone-logo]="!hData().showStepper"
      [icon]="hData().icon"
      [size]="hData().iconSize"
    ></pc-icon>

    <nav>
      <pc-progress-stepper
        [allowNavigation]="!isNavigationLocked()"
        [class.hidden]="!hData().showStepper"
        [completedPercentageTranslate]="hData().stepperCompletedText"
        [headerIcon]="hData().stepper.headerIcon"
        [isDevMode]="hData().stepper.isDevMode"
        [isMobile]="!hData().isDesktop()"
      >
        @for (step of hData().stepper.steps; track step.name; let index = $index) {
          <cdk-step [completed]="step.isCompleted" [label]="step.name | translate"></cdk-step>
        }
      </pc-progress-stepper>
    </nav>
  </div>
  @if (isAgentProcess()) {
    <pc-entity-banner
      [agentName]="agentName()"
      [isAgentProcess]="isAgentProcess()"
      [isDesktop]="isDesktop()"
      [textPosition]="'flex-start'"
      [translationText]="entityBannerText()"
    ></pc-entity-banner>
    @if (disclaimerName() && isShowDisclaimer()) {
      <pc-entity-banner
        [agentName]="disclaimerName()"
        [disclaimer]="true"
        [isAgentProcess]="isAgentProcess()"
        [isDesktop]="isDesktop()"
        [textPosition]="'flex-start'"
        [translationText]="entityBannerText()"
      ></pc-entity-banner>
    }
  }
</pc-header>
